import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TopicCardComponent } from './components/topic-card/topic-card.component';
import { VideoCardComponent } from './components/video-card/video-card.component';
import { InteractDirective } from './directives/interact.directive';
import { SubstitutionFieldsComponent } from './components/substitution-fields/substitution-fields.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';



@NgModule({
  declarations: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
  ],
  exports: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
  ]
})
export class SharedModule { }
